import React from "react";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { FAQ } from "@/constants/plantusTestIds";

const faqs = [
  {
    q: "Für wen ist Plantus gedacht?",
    a: "Plantus richtet sich an alle gewerblichen Anwender von Pflanzenschutzmitteln, Landwirte, Lohnunternehmer, Garten- und Landschaftsbau, Forst sowie Kommunen. Überall, wo eine Aufzeichnungspflicht nach § 11 PflSchG und EU 1107/2009 besteht, hilft Plantus, diese rechtssicher zu erfüllen.",
  },
  {
    q: "Was hat sich seit dem 1. Januar 2026 geändert?",
    a: "Mit der Durchführungsverordnung (EU) 2023/564 müssen seit dem 01.01.2026 alle PSM-Anwendungen umfassender und lückenlos dokumentiert werden. Plantus erfasst alle neuen Pflichtfelder automatisch, Sie müssen sich nicht in die Verordnung einarbeiten.",
  },
  {
    q: "Wann wird die elektronische, maschinenlesbare Form verpflichtend?",
    a: "Die Durchführungsverordnung (EU) 2023/564 schreibt ein elektronisches, maschinenlesbares Format vor. Über die Verordnung (EU) 2025/2203 dürfen die Mitgliedstaaten diese Pflicht bis zum 31.12.2026 verlängern, ab dem 01.01.2027 ist sie endgültig verbindlich. Plantus erzeugt diese Formate bereits heute.",
  },
  {
    q: "Erfüllt Plantus § 11 PflSchG und die EU-Verordnung 1107/2009?",
    a: "Ja. Plantus deckt sämtliche Pflichtangaben der EU-Verordnung 1107/2009, des § 11 Pflanzenschutzgesetz sowie der neuen Durchführungsverordnung (EU) 2023/564 ab, inklusive der erweiterten Datensätze, die seit 01.01.2026 gelten.",
  },
  {
    q: "Funktioniert die App auch ohne Internet?",
    a: "Vollständig. Alle Funktionen, Erfassung, GPS-Tracking und Wirkstoff-Datenbank, stehen offline zur Verfügung. Sobald wieder Empfang besteht, synchronisiert Plantus die Daten verschlüsselt mit der Cloud.",
  },
  {
    q: "Welche Wirkstoffdatenbank verwendet Plantus?",
    a: "Plantus greift auf die offizielle Liste zugelassener Pflanzenschutzmittel des Bundesamtes für Verbraucherschutz und Lebensmittelsicherheit (BVL) zu. Die Daten werden täglich aktualisiert.",
  },
  {
    q: "Wie sicher sind meine Daten?",
    a: "Sämtliche Daten werden Ende-zu-Ende verschlüsselt übertragen und in einem ISO-27001-zertifizierten Rechenzentrum in Frankfurt (DE) gespeichert. Sie behalten jederzeit das Eigentum an Ihren Daten.",
  },
  {
    q: "Wann ist Plantus in anderen EU-Ländern verfügbar?",
    a: "Wir starten in Deutschland und rollen Plantus schrittweise in weiteren EU-Mitgliedstaaten aus, jeweils angepasst an die nationalen Umsetzungen der EU 2023/564.",
  },
];

export const FAQSection = () => {
  return (
    <section
      id="faq"
      data-testid={FAQ.section}
      className="relative py-24 sm:py-32"
    >
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="mb-12">
          <div className="text-xs font-semibold uppercase tracking-[0.2em] text-terracotta mb-3">
            Fragen & Antworten
          </div>
          <h2 className="font-heading text-3xl sm:text-4xl lg:text-5xl font-semibold text-forest-900 tracking-tight">
            Häufige Fragen
          </h2>
        </div>

        <Accordion type="single" collapsible className="w-full">
          {faqs.map((item, i) => (
            <AccordionItem
              key={i}
              value={`item-${i}`}
              data-testid={FAQ.item(i)}
              className="border-b border-bone-200"
            >
              <AccordionTrigger
                data-testid={FAQ.trigger(i)}
                className="font-heading text-left text-base sm:text-lg font-medium text-forest-900 hover:no-underline py-5"
              >
                {item.q}
              </AccordionTrigger>
              <AccordionContent className="font-body text-[15px] text-[#4A524C] leading-relaxed pb-5 pr-6">
                {item.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
};
